export default __webpack_public_path__ + "static/media/vehicle.a4ad2791f771837319ec3555c506c790.svg";